import * as React from "react";
import {Container,Row, Col} from "reactstrap";

import "./Footer.css";

/**
 * 
 * 
 * @export
 * @class App
 * @extends {React.Component<{}, {}>}
 */
export default class Footer extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);       
    }  
    render() {
        return (       
            <Container className="footer">                
                <Row>
                    <Col sm="10">                
                    </Col>
                    <Col sm="2"> 
                        Powered by Art2Spot
                    </Col>
                </Row>
            </Container>
        );
    }
}






// WEBPACK FOOTER //
// ./src/components/views/Footer.tsx